import React from 'react';

import {CategoryHeader, Container, StoresColumn, StoresList} from './styles';
import {StoreShimmer} from '../StoreShimmer';
import LinearGradient from 'react-native-linear-gradient';
import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);

export function CategoryStoreShimmer() {
  const theme = useTheme();
  return (
    <Container>
      <CategoryHeader>
        <ShimmerPlaceHolder
          style={{width: RFValue(140)}}
          shimmerColors={theme.colors.shimmer_placeholder}
        />
      </CategoryHeader>
      <StoresList>
        <StoresColumn>
          <StoreShimmer first />
          <StoreShimmer />
          <StoreShimmer />
        </StoresColumn>
      </StoresList>
    </Container>
  );
}
